/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'
import type { VideoSurveyResponseInputScenarioId } from './videoSurveyResponseInputScenarioId'

/**
 * 動画詳細ページからのアンケート回答（設問1件ぶん）。
 */
export interface VideoSurveyResponseInput {
  /**
   * リード（PII）項目の設問で入力された値
   * @nullable
   */
  leadValue?: string | null
  /**
   * FREE 設問の自由記述
   * @nullable
   */
  freeText?: string | null
  /** 選択した選択肢ID。SINGLE=1件 / MULTI=複数 / FREE=空 */
  optionIds?: string[]
  /**
   * 流入元プレイリスト（関連動画付きページの `?from=`）。個別動画ページは未指定
   * @nullable
   */
  scenarioId?: VideoSurveyResponseInputScenarioId
  questionId: Cuid
  /** 視聴セッションID（クライアント生成） */
  sessionId: string
}
